import { render } from "./ProductSkeleton.vue?vue&type=template&id=7fc77704&scoped=true&lang=pug"
import script from "./ProductSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductSkeleton.vue?vue&type=script&lang=js"

import "./ProductSkeleton.vue?vue&type=style&index=0&id=7fc77704&scoped=true&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc77704"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
